"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = exports.vestingValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const constants_1 = require("@dzambalaorg/constants");
exports.vestingValidationSchema = (0, yup_1.object)().shape({
    owner: yup_rules_eth_1.addressValidationSchema,
    startTimestamp: (0, yup_1.string)()
        .matches(constants_1.reISO8601, "form.validations.patternMismatch")
        .required("form.validations.valueMissing"),
    cliffInMonth: (0, yup_1.number)()
        .typeError("form.validations.badInput")
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(0, "form.validations.rangeUnderflow"),
    monthlyRelease: (0, yup_1.number)()
        .typeError("form.validations.badInput")
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .max(10000, "form.validations.rangeOverflow")
        .min(1, "form.validations.rangeUnderflow"),
});
exports.validationSchema = (0, yup_1.object)().shape({
    parameters: exports.vestingValidationSchema,
    item: mui_inputs_asset_1.templateAssetValidationSchema,
});
//# sourceMappingURL=index.js.map